import { useRef, useState } from "react";

export function useRedraw() {
  const update = useRef(0);
  const [redraw, setReadraw] = useState(0);

  return () => {
    update.current = update.current + 1;
    setReadraw(update.current);
  };
}
